const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function isValidDateOnly(value: string): boolean {
  if (!DATE_ONLY_PATTERN.test(value)) {
    return false;
  }
  const [yearText, monthText, dayText] = value.split('-');
  const year = Number(yearText);
  const month = Number(monthText);
  const day = Number(dayText);
  const date = new Date(Date.UTC(year, month - 1, day));
  return (
    !Number.isNaN(date.getTime()) &&
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
}

export function parseDateOnly(value: string): Date | null {
  if (!isValidDateOnly(value)) {
    return null;
  }
  const [yearText, monthText, dayText] = value.split('-');
  return new Date(Date.UTC(Number(yearText), Number(monthText) - 1, Number(dayText)));
}

export function formatDateOnlyLong(value: string): string {
  const parsed = parseDateOnly(value);
  if (!parsed) {
    return value;
  }
  return new Intl.DateTimeFormat('en-ZA', {
    timeZone: 'UTC',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(parsed);
}

export function formatDateOnlyMonthLabel(year: number, monthIndex: number): string {
  return new Intl.DateTimeFormat('en-ZA', {
    timeZone: 'UTC',
    month: 'long',
    year: 'numeric'
  }).format(new Date(Date.UTC(year, monthIndex, 1)));
}

export function formatDateOnlyDayLabel(year: number, monthIndex: number, day: number): string {
  return new Intl.DateTimeFormat('en-ZA', {
    timeZone: 'UTC',
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(new Date(Date.UTC(year, monthIndex, day)));
}

export function dateOnlyValueOf(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function todayDateOnly(): string {
  return dateOnlyValueOf(new Date());
}
